export default function CloseThisWindow() {
  return "Please close this pop-up.";
}
